/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* 安全相关工具，比如加解密转码等 */
import CryptoJS from 'crypto-js';

// 对字符串进行加密(偏移加密)
export function compileStr1(code) {
  let c = String.fromCharCode(code.charCodeAt(0) + code.length);
  for (let i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
  }
  return escape(c);
}

// 对字符串进行解密(偏移解密)
export function uncompileStr1(code) {
  code = unescape(code);
  let c = String.fromCharCode(code.charCodeAt(0) - code.length);
  for (let i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
  }
  return c;
}
// 对字符串进行加密(无偏移)
export function compileStr(code) {
  return escape(code);
}

// 对字符串进行解密(无偏移)
export function uncompileStr(code) {
  return unescape(code);
}

/**
 * AES加密
 * @export
 * @param {*} string
 * @returns
 */
export function aesEncryption(key = '', string = '') {
  if (!string) {
    return '';
  }
  const parseKey = CryptoJS.enc.Utf8.parse(key);
  // ECB加密
  const options = {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  };
  const encryptedData = CryptoJS.AES.encrypt(string, parseKey, options);
  const encryptedBase64Str = encryptedData.toString();
  return encryptedBase64Str;
}

/**
 * AES解密
 * @export
 * @param {*} string
 * @returns
 */
export function aesDecryption(key = '', string = '') {
  if (!string) {
    return '';
  }
  const encryptedBase64Str = string;
  const options = {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  };
  const parseKey = CryptoJS.enc.Utf8.parse(key);
  // 解密
  const decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, parseKey, options);
  // 解密后，需要按照Utf8的方式将明文转位字符串
  const decryptedStr = decryptedData.toString(CryptoJS.enc.Utf8);
  return decryptedStr;
}

/**
 * AES加密(256)
 * @export
 * @param {*} string
 * @returns
 */
export function aesEncryption256(key = '', string = '', iv = '') {
  if (!string) {
    return '';
  }
  const parseKey = CryptoJS.enc.Utf8.parse(key);
  iv = CryptoJS.enc.Utf8.parse(iv);
  // CBC加密
  const options = {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv,
  };
  const encryptedData = CryptoJS.AES.encrypt(string, parseKey, options);
  const encryptedBase64Str = encryptedData.toString();
  return encryptedBase64Str;
}

/**
 * AES解密(256)
 * @export
 * @param {*} string
 * @returns
 */
export function aesDecryption256(key = '', string = '', iv = '') {
  if (!string) {
    return '';
  }
  const encryptedBase64Str = string;
  iv = CryptoJS.enc.Utf8.parse(iv);
  const options = {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv,
  };
  const parseKey = CryptoJS.enc.Utf8.parse(key);
  // 解密
  const decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, parseKey, options);
  // 解密后，需要按照Utf8的方式将明文转位字符串
  const decryptedStr = decryptedData.toString(CryptoJS.enc.Utf8);
  return decryptedStr;
}

/**
 * DES加密
 * @export
 * @param {*} string
 * @returns
 */
export function encryptDes(message, keyStr) {
  keyStr = keyStr || 'jhs_dnsadkas-0w3';
  const keyHex = CryptoJS.enc.Utf8.parse(keyStr);
  /* 这里的模式参数需要和后端匹配 mode.ECB，mode.CBC */
  const encrypted = CryptoJS.DES.encrypt(message, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString();
}

/**
 * DES解密
 * @export
 * @param {*} string
 * @returns
 */
export function decryptDes(message, keyStr) {
  keyStr = keyStr || 'jhs_dnsadkas-0w3';
  const keyHex = CryptoJS.enc.Utf8.parse(keyStr);
  const decrypted = CryptoJS.DES.decrypt(
    {
      ciphertext: CryptoJS.enc.Hex.parse(message),
    },
    keyHex,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    },
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
}

/**
 * 扁平数据解析成为树形结构
 *
 */
export function buildTree(data) {
  const parents = data.filter((value) => value.navType == 0);
  const children = data.filter((value) => value.navType !== 0);
  const translator = (parents, children) => {
    parents.forEach((parent) => {
      children.forEach((current, index) => {
        if (current.parentId * 1 === parent.id) {
          let temp = JSON.parse(JSON.stringify(children));
          temp.splice(index, 1);
          translator([current], temp);
          typeof parent.children !== 'undefined' ? parent.children.push(current) : (parent.children = [current]);
        }
      });
    });
  };
  translator(parents, children);
  return parents;
}
